import React from 'react'
import propTypeSchema from 'react-json-schema-proptypes'
import { Typography } from '../types'
import { markdown } from '../common'
import Radium, { Style } from 'radium'

const schema = {
  'type': 'object',
  'required': ['text'],
  'properties': {
    'text': { 'type': 'string' },
    'textStyle': Typography.Schema,
    'secondText': { 'type': 'string' },
    'strongText': { 'type': 'string' },
    'secondTextStyle': Typography.Schema,
    'strongStyle': Typography.Schema,
    'backgroundBanner': { 'type': 'string'}
  }
}

@Radium
export default class AlphaSidebar extends React.PureComponent {
  static propSchema = schema
  static propTypes = propTypeSchema(schema, {
    'required': ['assetLoader'],
    'properties': {
      'assetLoader': { 'isFunction': true }
    }
  })
  static defaultProps = {
    backgroundBanner: 'sidebar-background.png'
  }

  render () {
    const styles = {
      text: this.props.textStyle,
      secondText: this.props.secondTextStyle,
      strongStyle: this.props.strongStyle,
      background: {
        backgroundImage: `url(${this.props.assetLoader(this.props.backgroundBanner)})`
      }
    }
    return (
      <div className='alpha'>
        {this.props.text &&
        <span className='rightText' style={[styles.text]}>{this.props.text}</span>
        }
        {this.props.strongText &&
        <span className='rightText' style={[styles.strongStyle]}>
          <Style
            scopeSelector=".rightText"
            rules={{
              p: {
                margin: 0
              }
            }}
          />
          {markdown(this.props.strongText)}
        </span>
        }
        {this.props.secondText &&
        <span className='rightText' style={[styles.secondText]}>
          {markdown(this.props.secondText)}
        </span>
        }
        {!this.props.text &&
        <div className='rightBanner' style={[styles.background]} />
        }
      </div>
    )
  }
}
